import { ChiptaElement, html, css, unsafeCSS } from 'chipta-libs/main.js';


class LayoutChiptaLogoBackground extends ChiptaElement {

  render() {
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 772 457"
        width="772"
        height="457"
      >
        <g>
          <path d="M238.203 518.442L438.146 253.377C444.227 245.311 443.034 233.505 435.479 227.012L310.236 118.849C302.592 112.281 301.469 100.291 307.747 92.2386L320.68 75.6635C351.254 36.5864 385.369 25.1753 408.606 22.4911C437.247 19.1734 466.29 27.4507 486.272 44.6117L724.784 249.528C728.906 253.064 731.305 258.398 731.33 264.046L732.077 442.039C732.153 457.817 715.029 466.619 703.512 456.727L594.379 362.031C586.831 355.539 575.78 356.813 569.706 364.879L369.706 630.019C363.625 638.085 352.575 639.359 345.021 632.86L240.857 544.8C233.309 538.308 232.123 526.508 238.203 518.442Z" />
          <path d="M376.73 892.031C342.513 895.962 310.063 884.251 277.518 856.258L34.2718 646.955C-12.3038 606.89 -17.0124 523.796 24.1655 469.152L266.052 147.413C272.133 139.341 283.19 138.073 290.731 144.559L391.353 231.004C398.908 237.497 400.101 249.303 394.02 257.369L195.328 522.284C186.836 532.796 188.864 542.824 199.079 551.667L349.518 681.065C356.702 687.238 367.211 686.032 373.01 678.368L577.432 407.778C582.026 401.694 590.359 400.74 596.063 405.639L700.449 495.327C708.01 501.819 709.197 513.632 703.116 521.691L459.628 843.716C438.975 871.076 409.556 888.23 376.8 892.025L376.73 892.031Z" />
        </g>

      </svg>
    `;
  }

  static get styles() {
    return css`
      svg {
        display: block;
        bottom: 0;
        right: 0;
        width: auto;
        pointer-events: none;
        position: absolute;
      }
      path {
        fill: white;
        fill-opacity: 0.05;
      }
    `;
  }

}


customElements.define('layout-chipta-logo-background', LayoutChiptaLogoBackground);
